import {ModelBase} from "../../../models/model-base";
import {IModelBase} from "../../../models/i-model-base";
import {CashPointEntryState} from "./_enums/cash-point-entry-state";
import {LegalProvider} from "../../legal/_models/_enums/legal-provider";

export class CashPointEntryBase extends ModelBase implements IModelBase {
  state: CashPointEntryState = CashPointEntryState.Opened;
  employeeId?: string = undefined;
  legalProvider: LegalProvider = LegalProvider.None;
}
